import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { IssueService } from '../../services/issue.service';
import { StorageService } from '../../services/storage.service';
import { RoleType } from '../../models/user.model';
import { ClaimsService } from '../../services/claims.service';


@Component({
    selector: 'issues',
    templateUrl: './issues.component.html',
    styleUrls: ['./issues.component.scss']
})

export class IssuesComponent implements AfterViewInit, OnDestroy {

    navigationList: any[] = [];
    clientId: number;
    subscriptions: any[] = [];
    promiseArray: any[] = [];
    tabItem: string = "Summary";

    paygNumberOfIssues: number = 0;
    paygNumberOfConsumerWithIssues: number = 0;
    totalNumberIssues: number = 0;

    billingNumberOfIssues: number = 0;
    billingOfConsumerWithIssues: number = 0;

    consumptionNumberOfIssues: number = 0;
    consumptionOfConsumerWithIssues: number = 0;

    isSuperUser: boolean = false;
    isPayg: boolean = false;
    isBilling: boolean = false;
    isMetering: boolean = false;
    hasLoaded: boolean = false;

    constructor(
        private claimsService: ClaimsService,
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private storageService: StorageService
    ) {}

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInitialise() {
        this.totalNumberIssues = 0;
        try {
            this.isSuperUser = this.claimsService.isSuperUser();
            this.isPayg = this.claimsService.hasPaygFeature();
            this.isBilling = this.claimsService.hasBillingFeature();
            this.isMetering = this.claimsService.hasConsumptionFeature();
        } catch { }

        this.clientId = this.route.parent.snapshot.params['clientId'];

        let billingSummaryPromise = this.issueService.billingSummary(this.clientId);
        let paygSummaryPromise = this.issueService.paygSummary(this.clientId);
        let consumptionSummaryPromise = this.issueService.getConsumptionSummary(this.clientId);

        if (this.isPayg) { this.promiseArray.push(['payg', this.isPayg, paygSummaryPromise]); }
        if (this.isBilling) { this.promiseArray.push(['billing', this.isBilling, billingSummaryPromise]); }
        if (this.isMetering) { this.promiseArray.push(['metering',this.isMetering, consumptionSummaryPromise]); }
        
        if (!this.hasLoaded) {
            Promise.all(this.returnValuesFrom(this.promiseArray)).then(
                result => {
                    let res = result as any;
                    this.totalNumberIssues = 0;
                    this.billingNumberOfIssues = 0;
                    this.paygNumberOfIssues = 0;
                    this.consumptionNumberOfIssues = 0;

                    for (let i = 0; i < this.promiseArray.length; i++) {
                        for (let j = 0; j < this.promiseArray.length; j++) {
                            if (this.promiseArray[i][j] == 'payg') {
                                this.paygNumberOfIssues = (this.isSuperUser || this.isPayg) ? res[i].numberOfIssues : 0;
                                this.paygNumberOfConsumerWithIssues = (this.isSuperUser || this.isPayg) ? res[i].numberofConsumersExperiencingIssues : 0;
                            }

                            if (this.promiseArray[i][j] == 'billing') {
                                this.billingNumberOfIssues = (this.isSuperUser || this.isBilling) ? res[i].numberOfIssues : 0;
                                this.billingOfConsumerWithIssues = (this.isSuperUser || this.isBilling) ? res[i].numberofConsumersExperiencingIssues : 0;
                            }

                            if (this.promiseArray[i][j] == 'metering') {
                                this.consumptionNumberOfIssues = (this.isSuperUser || this.isMetering) ? res[i].numberOfIssues : 0;
                                this.consumptionOfConsumerWithIssues = (this.isSuperUser || this.isMetering) ? res[i].numberofConsumersExperiencingIssues : 0;
                            }

                        }
                    }

                    this.totalNumberIssues = this.paygNumberOfIssues + this.billingNumberOfIssues + this.consumptionNumberOfIssues;
                    this.createOrUpdateNavList();
                },
                error => {
                    if (this.isBilling || this.isSuperUser) {
                        this.issueService.billingSummary(this.clientId).then((billResult) => {

                            this.billingNumberOfIssues = billResult.numberOfIssues;
                            this.billingOfConsumerWithIssues = billResult.numberofConsumersExperiencingIssues;

                            this.totalNumberIssues = this.billingNumberOfIssues;
                            this.createOrUpdateNavList();

                        });
                    }

                    if (this.isPayg || this.isSuperUser) {
                        this.issueService.paygSummary(this.clientId).then((paygResult) => {

                            this.paygNumberOfIssues = paygResult.numberOfIssues;
                            this.paygNumberOfConsumerWithIssues = paygResult.numberofConsumersExperiencingIssues;

                            this.totalNumberIssues = this.paygNumberOfIssues;
                            this.createOrUpdateNavList();

                        });
                    }

                    if (this.isPayg || this.isMetering) {
                        this.issueService.getConsumptionSummary(this.clientId).then((conResult) => {

                            this.consumptionNumberOfIssues = conResult.numberOfIssues;
                            this.consumptionOfConsumerWithIssues = conResult.numberofConsumersExperiencingIssues;

                            this.totalNumberIssues = this.consumptionOfConsumerWithIssues;
                            this.createOrUpdateNavList();

                        });
                    }
                }
            )
        }
    }

    createOrUpdateNavList() {
        let component = this.router.routerState.snapshot.url.split('/');

        if (this.navigationList.length == 0) {
            this.navigationList.push(
                {
                    key: "summary",
                    label: "Summary",
                    value: this.totalNumberIssues,
                    route: ["/portal/" + this.clientId.toString() + "/issues", "summary"],
                    isDisabled: false,
                    isClicked: true
                },
                {
                    key: "payg",
                    label: "PAYG",
                    value: (this.isSuperUser || this.isPayg) ? this.paygNumberOfIssues : 0,  // if super user or payg then get the number of issues
                    route: ["/portal/" + this.clientId.toString() + "/issues", "payg"],
                    isDisabled: (!this.isSuperUser && !this.isPayg),
                    isClicked: false
                },
                {
                    key: "billing",
                    label: "Billing",
                    value: (this.isSuperUser || this.isBilling) ? this.billingNumberOfIssues : 0,
                    route: ["/portal/" + this.clientId.toString() + "/issues", "billing"],
                    isDisabled: (!this.isSuperUser && !this.isBilling),
                    isClicked: false
                },
                {
                    key: "metering",
                    label: "Metering",
                    value: (this.isSuperUser || this.isMetering) ? this.consumptionNumberOfIssues : 0,
                    route: ["/portal/" + this.clientId.toString() + "/issues", "metering"],
                    isDisabled: (!this.isSuperUser && !this.isMetering),
                    isClicked: false
                }
            )

        } else {
            this.navigationList[0].route = ["/portal/" + this.clientId.toString() + "/issues", "summary"];
            this.navigationList[1].route = ["/portal/" + this.clientId.toString() + "/issues", "payg"];
            this.navigationList[2].route = ["/portal/" + this.clientId.toString() + "/issues", "billing"];
            this.navigationList[3].route = ["/portal/" + this.clientId.toString() + "/issues", "metering"];
        }
    }

    returnValuesFrom(array: any[]): any {
        let retArray = [];
        for (let i = 0; i < array.length; i++) {
            if (array[i][1] == true) {
                retArray.push(array[i][2]);
            }
        }

        return retArray;
    }

    onClick(index: number) {
        if (this.navigationList[index].isDisabled) return;

        this.clientId = this.route.parent.snapshot.params['clientId'];

        for (let i = 0; i < this.navigationList.length; i++) {
            this.navigationList[i].isClicked = false;
        }

        this.navigationList[index].isClicked = true;
        this.tabItem = this.navigationList[index].label;

    }

}
